import { __rest, __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { useTheme } from '../../hooks/useTheme.js';
import { useLinkComponent } from '../../UIProvider/linkComponentContext.js';
import { Box } from '../../Box/index.js';

var isExternalTest = new RegExp("^(https?:|mailto:)");
var isExternal = function (href) { return isExternalTest.test(href); };
var LinkBase = forwardRef(function (_a, ref) {
    var _b = _a.disabled, disabled = _b === void 0 ? false : _b, sx = _a.sx, href = _a.href, onClick = _a.onClick, linkProps = __rest(_a, ["disabled", "sx", "href", "onClick"]);
    var applyTheme = useTheme().applyTheme;
    var css = applyTheme(sx);
    var props = __assign(__assign({ css: css, ref: ref, "data-disabled": disabled, "aria-disabled": disabled }, linkProps), (!disabled && { href: href, onClick: onClick }));
    var LinkComponent = useLinkComponent(ref);
    return jsx(Box, __assign({ as: LinkComponent }, props));
});
LinkBase.displayName = "LinkBase";

export { LinkBase, isExternal };
//# sourceMappingURL=index.js.map
